// extracted by mini-css-extract-plugin
export var csatScore = "_nq-5";
export var header = "_nq-1";
export var panelWrapper = "_nq-2";
export var postPreview = "_nq-3";
export var rightContent = "_nq-0";
export var wrappingText = "_nq-4";